import { Reducer } from "redux";

import { NotificationsResponse } from "../models/api/Admin";
import { NotificationActionTypes } from "../models/dispatchTypes/User";
import { NotificationActionDispatchTypes } from "../constants/User";

const initialState: NotificationsResponse = {
  loading: false,
  response: null,
  error: null,
};

const PostNotificationReducer: Reducer<
NotificationsResponse,
NotificationActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case NotificationActionDispatchTypes.POST_NOTIFICATION_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case NotificationActionDispatchTypes.POST_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case NotificationActionDispatchTypes.POST_NOTIFICATION_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case NotificationActionDispatchTypes.POST_NOTIFICATION_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PostNotificationReducer;
